export const LOGIN_SUCCESS = "login-success";
export const LOGOUT_REQUEST = "logout-request";
export const SET_SOCKET = "set-socket-connection";
export const UPDATE_USER = "update-user";
